import { reactive } from "vue";

interface IColumnConfig {
 [key: string]: IColumnItem;
  }
  
  export interface IColumnItem {
  displayName: string;
  visible: boolean;
  priority: number;
}

export const columnConfig: IColumnConfig = reactive({
  name:            { displayName: "Namn",                       visible: true, priority: 1 },
  alternateNames:  { displayName: "Alternativa namn",           visible: true, priority: 2 },
  type:            { displayName: "Typ",                        visible: false, priority: 3 },
  launchDate:      { displayName: "Sjösatt/Infört i flottan",   visible: true, priority: 4 },
  displacement:    { displayName: "Ton",                        visible: false, priority: 5 },
  navalBattles:    { displayName: "Deltog i",                   visible: false, priority: 6 },
  suspension:      { displayName: "Avslut/Avfört ur flottan",   visible: true, priority: 7 },
  constructionSite:{ displayName: "Byggnadsort",                visible: false, priority: 8 },
  constructor:     { displayName: "Byggmästare",                visible: false, priority: 9 },
  status:          { displayName: "Lägesbestämd",               visible: false, priority: 10 },
  length:          { displayName: "Längd",                      visible: false, priority: 11 },
  width:           { displayName: "Bredd",                      visible: false, priority: 12 },
  numberOfCannons: { displayName: "Kanoner",                    visible: false, priority: 13 },
  numberOfSailors: { displayName: "Sjöfolk",                    visible: false, priority: 14 },
  numberOfSoldiers:{ displayName: "Soldater",                   visible: false, priority: 15 },
  crewTotal:       { displayName: "Total besättning",           visible: false, priority: 16 },
  fates:           { displayName: "Öde",                        visible: false, priority: 17 },
  /* woodType:     { displayName: "Träslag",                    visible: false, priority: 18 }, Temporary  */
  comments:         { displayName: "Kommentar",                  visible: false, priority: 19 },
});

export const initialVisibility: Record<string, boolean> = Object.fromEntries(
  Object.entries(columnConfig).map(([key, cfg]) => [key, cfg.visible])
);